import React from "react";

export class SB1ErrorBoundary extends React.Component {

  state = {
    error: null,
  };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidMount() {
    window.onerror = 
    (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) => {
        if (typeof event === 'string') {
            this.logError(Error(event));
        } else if (event instanceof ErrorEvent) {
            this.logError(error);
        }
    }
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("TRacking error: ", error, errorInfo)
  }
  logError(error?: Error) {
    console.error("error: ", error)
  }
  render() {
    if (this.state.error) {
      return "such error"; // as before
    }
    return this.props.children;
  }
}